import { Divider } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import AccountBankCodeInput from "../Accounts/AccountBankCodeInput";
import AccountBankOwnerInput from "../Accounts/AccountBankOwnerInput";
import AccountIbanInput from "../Accounts/AccountIbanInput";
import AccountNumberInput from "../Accounts/AccountNumberInput";
import AccountPrefixInput from "../Accounts/AccountPrefixInput";
import AccountSwiftInput from "../Accounts/AccountSwiftInput";

const PartnerBankingSection = ({ partner, readOnly }) => {
  const { t } = useTranslation();

  return (
    <React.Fragment>
      <Divider orientation="left">{t("common.bankingInformation")}</Divider>
      <AccountPrefixInput
        initialValue={partner?.account_prefix}
        readOnly={readOnly}
      />
      <AccountNumberInput
        initialValue={partner?.account_number}
        readOnly={readOnly}
      />
      <AccountBankCodeInput
        initialValue={partner?.account_bank_code}
        readOnly={readOnly}
      />
      <AccountIbanInput
        initialValue={partner?.account_iban}
        readOnly={readOnly}
      />
      <AccountSwiftInput
        initialValue={partner?.account_swift}
        readOnly={readOnly}
      />
      <AccountBankOwnerInput
        initialValue={partner?.account_bank_owner}
        readOnly={readOnly}
        required
        strict={partner?.currency_iso_4217 === "EUR"}
      />
    </React.Fragment>
  );
};

export default PartnerBankingSection;
